import { validAmount } from './../common-helpers';

export const getTotalAmount = (list: string[]) => list.reduce((acc, cur) => acc + +validAmount(cur), 0);
